import { faGoogle, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GoogleLogin } from "@react-oauth/google";
import React, { useEffect, useState } from "react";
import { useAuthProviders } from "../../helper/auth/AuthProviderContext";
import { Alert, Button, Form, FormGroup } from "react-bootstrap";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import * as Actions from "../../constants/baseUrl";
import { useGoogleLoginMutation } from "../../helper/auth/login-api";
import ForgotPasswordPopup from "../../pages/auth/forgot-password/forget-password-popup";
import { setCookie } from "../../utils/cookies";
import API from "../API/API";

const LoginForm = ({ mode, setLoading, onSubmit, formRef, signupErrorMsg }) => {
  const [userRoles, setUserRoles] = useState([]);
  const [show, setShow] = useState(false);
  const [isPassword, setIsPassword] = useState(true);
  const [passwordData, setPasswordData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isSamePassword, setIsSamePassword] = useState(true);
  const { googleClient, linkedInClient } = useAuthProviders();

  const [googleLogin] = useGoogleLoginMutation();

  useEffect(() => {
    const fetchData = () => {
      API("get", "configs/pagesettings/auth", {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      })
        .then((data) => {
          setUserRoles(data?.userRole);
          setLoading(false);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    };

    fetchData();
  }, []);

  const handleGoogleClick = async (token) => {
    setLoading(true);

    const data = await googleLogin({ token: token })
      ?.unwrap()
      .catch(() => {
        toast.error("Unable to signin. Pleas try again later");
      })
      .finally(() => setLoading(false));
    if (!data) return;
    setCookie("token", data.authToken, { expires: 7, secure: true });
    localStorage.setItem("isValidUser", true);
    localStorage.setItem("userData", JSON.stringify(data));
    window.location.href = "/";
  };

  const handleLinkedInClick = () => {
    const redirectUri = encodeURIComponent(Actions.Redirect_Url);
    const state = crypto.randomUUID();
    const scope = "openid profile email";

    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedInClient}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;
    window.location.href = linkedInAuthUrl;
  };

  useEffect(() => {
    setIsSamePassword(passwordData.password === passwordData.confirmPassword);
  }, [passwordData.confirmPassword, passwordData.password]);

  return (
    <>
      <Form
        onSubmit={(e) => {
          onSubmit(e);
        }}
        ref={formRef}
        className="loginform"
      >
        <div
          className={`form-input-wrapper align-items-start overflow-hidden ${
            mode ? "login" : "signup"
          }`}
        >
          <input type="hidden" id="mode" defaultValue={mode} />
          {/* SIgn In */}
          <div className="form-login">
            <header className="form-block__header mb-4 theme-text-2">
              <h4 className="headertxt text-center"> Welcome back! </h4>
            </header>
            <FormGroup className="form-floating mb-3">
              <Form.Control
                autoFocus
                type="text"
                id="email"
                label="email"
                disabled={!mode}
                placeholder="Type Here"
                required
              />
              <Form.Label htmlFor="email">User Name or Email</Form.Label>
            </FormGroup>
            <FormGroup className="form-floating password-group mb-3">
              <Form.Control
                type={isPassword ? "password" : "text"}
                id="password"
                label="password"
                required
                disabled={!mode}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="password">Password</Form.Label>
              <Button className="bg-transparent border-0 p-0 passwordToggler">
                {isPassword ? (
                  <Eye onClick={() => setIsPassword(!isPassword)} />
                ) : (
                  <EyeSlash onClick={() => setIsPassword(!isPassword)} />
                )}
              </Button>
            </FormGroup>

            <Button
              className="forgot_password btn p-0 bg-transparent text-danger border-0 ms-auto d-block"
              disabled={!mode}
              onClick={() => {
                setShow(true);
              }}
            >
              Forgot Password?
            </Button>

            <Button
              className={`add-button w-100 d-block my-3 btn-${
                mode ? "login" : "signup"
              }`}
              type="submit"
            >
              Log In
            </Button>

            {localStorage.getItem("isValidUser") === false ||
            localStorage.getItem("isValidUser") === "false" ? (
              <Alert className="py-2" key="danger" variant="danger">
                ❗ Invalid Credentials
              </Alert>
            ) : (
              ""
            )}
          </div>
          {/* Signup */}
          <div className={`form-signup ${mode ? "h-0" : ""}`}>
            <header className="form-block__header  mb-4 theme-text-2">
              <h3 className="headertxt text-center"> Create An Account </h3>
            </header>
            <FormGroup className="form-floating mb-3">
              <Form.Control
                autoFocus
                type="text"
                id="firstname"
                label="first name"
                required
                disabled={mode}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="firstname">First Name</Form.Label>
            </FormGroup>
            <FormGroup className="form-floating mb-3">
              <Form.Control
                type="text"
                id="lastname"
                label="last name"
                required
                disabled={mode}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="lastname">Last Name</Form.Label>
            </FormGroup>

            <FormGroup className="form-floating mb-3">
              <Form.Control
                type="newEmail"
                id="newEmail"
                label="newEmail"
                required
                disabled={mode}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="newEmail">Email</Form.Label>
            </FormGroup>

            <FormGroup className="form-floating password-group mb-3">
              <Form.Control
                type={isPassword ? "password" : "text"}
                id="createpassword"
                required
                label="password"
                disabled={mode}
                value={passwordData.password}
                onChange={(e) => {
                  setPasswordData({
                    ...passwordData,
                    password: e.target.value,
                  });
                }}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="password">Password</Form.Label>
              <Button className="bg-transparent border-0 p-0 passwordToggler">
                {isPassword ? (
                  <Eye onClick={() => setIsPassword(!isPassword)} />
                ) : (
                  <EyeSlash onClick={() => setIsPassword(!isPassword)} />
                )}
              </Button>
            </FormGroup>

            {!isSamePassword && (
              <small className="text-end d-block text-dark">
                <small className="text-danger">Passwords does not match.</small>
              </small>
            )}
            <FormGroup className="form-floating password-group mb-3">
              <Form.Control
                type={isPassword ? "password" : "text"}
                id="repeatpassword"
                className={isSamePassword ? "" : "border-danger"}
                required
                label="repeat password"
                disabled={mode}
                value={passwordData.confirmPassword}
                onChange={(e) => {
                  setPasswordData({
                    ...passwordData,
                    confirmPassword: e.target.value,
                  });
                }}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="repeatpassword">Repeat Password</Form.Label>
            </FormGroup>

            <FormGroup className="form-floating mb-3">
              <Form.Control
                type="phone"
                id="phone"
                required
                label="phone"
                disabled={mode}
                placeholder="Type Here"
              />
              <Form.Label htmlFor="phone">Phone</Form.Label>
            </FormGroup>

            <FormGroup className="form-floating mb-3">
              <Form.Select id="role" required disabled={mode}>
                <option value="">Select Account type</option>
                {userRoles?.length > 0 ? (
                  userRoles?.map((role, index) => (
                    <option
                      value={role?.key}
                      key={index + role.key}
                      className="text-capitalize"
                    >
                      {role.value}
                    </option>
                  ))
                ) : (
                  <option value={"trainer"} className="text-capitalize">
                    trainer
                  </option>
                )}
              </Form.Select>
              <Form.Label htmlFor="select">Create Account As</Form.Label>
            </FormGroup>

            {signupErrorMsg !== "" && (
              <Alert className="p-2" variant="danger">
                <small>⚠ {signupErrorMsg}</small>
              </Alert>
            )}

            <Button
              className={`add-button w-100 d-block mt-3 btn-${
                mode ? "login" : "signup"
              }`}
              disabled={!isSamePassword}
              type="submit"
            >
              Sign Up
            </Button>
          </div>
        </div>

        <div className="form-bottom">
          {linkedInClient || googleClient ? (
            <div className="d-flex align-items-center justify-content-center gap-2 my-3 text-center">
              <hr width="20%" />
              <span>Or Continue with</span>
              <hr width="20%" />
            </div>
          ) : null}

          <div className="d-flex gap-3 justify-content-center align-items-center">
            {googleClient && (
              <GoogleLogin
                type="icon"
                size="large"
                shape="circle"
                theme="filled_blue"
                onSuccess={(credentialResponse) => {
                  const token = credentialResponse.credential;
                  if (token) {
                    setLoading(true);
                    handleGoogleClick(token);
                  }
                }}
              />
            )}

            {/* <Button
              className={`button-login-option btngithub btn-${
                mode ? "login" : "signup"
              }`}
              type="button"
              title="Sign in with Github"
              onClick={handleGitHubClick}
            >
              <FontAwesomeIcon icon={faGithub} />
            </Button> */}
            {linkedInClient && (
              <Button
                className={`button-login-option btnlinkedin btn-${
                  mode ? "login" : "signup"
                }`}
                type="button"
                title="Sign in with LinkedIn"
                onClick={handleLinkedInClick}
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </Button>
            )}
          </div>
        </div>
      </Form>

      <ForgotPasswordPopup show={show} onHide={() => setShow(false)} />
    </>
  );
};

export default LoginForm;
